const itemsData = {
  Id: 0,
  boxLines: [
    {
      rowList: [
        { title: "业务联系人: ", banding: "Name", value: "" },
        { title: "联系电话: ", banding: "Mobile", value: "" }
      ]
    },
    {
      rowList: [
        { title: "QQ: ", banding: "QQ", value: "" },
        { title: "邮箱:   ", banding: "Email", value: "" }
      ]
    },
    {
      rowList: [
        { title: "是否禁用: ", banding: "IsDefault", value: "", dataType: 'Type', dataMap: {true: '已禁用', false: '未禁用'} }
      ]
    }
  ]
};
export {
  itemsData
}
